import styled, { css } from 'styled-components';
import { Flex } from 'ui';

export const ActionsBar = styled(Flex)`
  ${({ theme: { space } }) => css`
    justify-content: flex-end;
    gap: ${space.s20};
  `}
`;
